export default __webpack_public_path__ + "static/retail-product-showcase-64078d247c4be440d37a3a1d43883867.gif";